import { MrbBaseRouteStore } from "mrb/core";
import { LoadioService } from "common/services";

class LoadioConfigurationRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);

        this.service = rootStore.createApplicationService(LoadioService);
    }

    async updateMasterPassword(resources) {
        const response = await this.service.updateMasterPassword(resources);
        return response.data;
    }
}

export default LoadioConfigurationRouteStore;
